/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromotionalLinkModel } from '../../models/promotional-link-model';

export interface AnonymousPromotionalLinkSlugSlugGet$Params {
  slug: string;
}

export function anonymousPromotionalLinkSlugSlugGet(http: HttpClient, rootUrl: string, params: AnonymousPromotionalLinkSlugSlugGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<PromotionalLinkModel>> {
  const rb = new RequestBuilder(rootUrl, anonymousPromotionalLinkSlugSlugGet.PATH, 'get');
  if (params) {
    rb.path('slug', params.slug, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<PromotionalLinkModel>;
    })
  );
}

anonymousPromotionalLinkSlugSlugGet.PATH = '/Anonymous/PromotionalLink/Slug/{slug}';
